import { render } from "./KardexViews.vue?vue&type=template&id=25273fd7&scoped=true"
import script from "./KardexViews.vue?vue&type=script&lang=js"
export * from "./KardexViews.vue?vue&type=script&lang=js"

import "./KardexViews.vue?vue&type=style&index=0&id=25273fd7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25273fd7"]])

export default __exports__